import axios from 'axios'


// let api = window.location.href.indexOf('8081') >= 0 ? '/api' : ''
const env = process.env.NODE_ENV
const api = env === 'development' ? '/api' : ''


export function submitForm(formData) {
  console.log('formData', formData)
  const url = `${api}/index/resume/inputok.html`

  return axios({
    method: "POST",
    url,
    data: formData,
    timeout: 10000,
    // headers: {
    //   'Content-Type' : 'application/x-www-form-urlencoded'
    // }
  })
  .then(res => {
    return Promise.resolve(res.data)
  })
  .catch(err => {
    console.log(err)
  })
}



// WEBPACK FOOTER //
// ./src/api/submit.js